<template>
  <div class="m_table">
    <ul class="m_table_ul">
      <li class="m_table_li"
          v-for="(item, index) in items"
          :key="index"
          @click="fnView(item)">
        <div class="col">
          <div :class="item.isTop === 1 ? 'm_table_ttl' : 'm_table_con'">
            <div class="tag color" v-show="item.isTop === 1"><span>공지</span></div>
            <span style="color: black">{{ item.title }}</span>
          </div>
          <div class="date"><span>{{ $moment(item.regDate).format('YYYY.MM.DD') }}</span></div>
        </div>
      </li>
    </ul>
    <div class="empty_wrap" v-if="$Util.isEmpty(items)">
      <div class="empty">
        <span>내역이 존재하지 않습니다.</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news-list-index',
  props: {
    items: {
      type: [Array],
      default: () => []
    },
    pageInfo: {
      type: [Object],
      default: () => {}
    }
  },
  methods: {
    fnView: function(item) {
      this.$emit('view', item)
    }
  }
}
</script>

<style scoped></style>
